import './App.css';
import Logo from './logo/Logo';
import Navbar from './navbar/Navbar';
import "./getfullcard/Fullcard.css"

function App() {
  return (
    <>
    <div className="container">
      <Logo/>
      <Navbar/>
    </div>
    
    
    </>
   
  );
};

export default App;
